import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";

export class Intro extends React.Component {
    //public/assets/img/intro-bg.jpg
    render() {
        return <section
            id="intro"
            style={
                {backgroundImage: `url(${this.props.hugeImageSrc})`}
            }>
            <animated.div style={this.props.style} className="intro-container">
                {this.props.title}
                <p className="mb-4 pb-0">{this.props.subTitle}</p>
                <a href={this.props.videoUrl} className="venobox play-btn mb-4" data-vbtype="video" data-autoplay="true"/>
                <a href={this.props.buttonHref} className="about-btn scrollto">{this.props.buttonText}</a>
            </animated.div>
        </section>;
    }
}

Intro.propTypes = {
    style: PropTypes.any,
    title: PropTypes.any,
    subTitle: PropTypes.any,
    videoUrl: PropTypes.string,
    buttonHref: PropTypes.string,
    buttonText: PropTypes.any,
    hugeImageSrc: PropTypes.string
};